var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextToSpeech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 24,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 18C8.87 18 8.5875 17.8825 8.3525 17.6475C8.1175 17.4125 8 17.13 8 16.8V7.2C8 6.87 8.1175 6.5875 8.3525 6.3525C8.5875 6.1175 8.87 6 9.2 6H14.09L12.89 7.2H9.2V16.8H15.8V15.6H17V16.8C17 17.13 16.8825 17.4125 16.6475 17.6475C16.4125 17.8825 16.13 18 15.8 18H9.2ZM10.4 15.6V14.4H14.6V15.6H10.4ZM10.4 13.8V12.6H13.4V13.8H10.4Z",
    fill: "#1D1D39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 13.2742L13.8 10.9516H12V8.04839H13.8L16.2 5.72581V13.2742ZM17.4 11.5032V7.49677C17.76 7.7 18.05 7.97581 18.27 8.32419C18.49 8.67258 18.6 9.06452 18.6 9.5C18.6 9.93548 18.49 10.3274 18.27 10.6758C18.05 11.0242 17.76 11.3 17.4 11.5032ZM17.4 14V12.7806C18.1 12.5387 18.675 12.1202 19.125 11.525C19.575 10.9298 19.8 10.2548 19.8 9.5C19.8 8.74516 19.575 8.07016 19.125 7.475C18.675 6.87984 18.1 6.46129 17.4 6.21935V5C18.44 5.26129 19.3 5.80565 19.98 6.63306C20.66 7.46048 21 8.41613 21 9.5C21 10.5839 20.66 11.5395 19.98 12.3669C19.3 13.1944 18.44 13.7387 17.4 14Z",
    fill: "#895EF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextToSpeech);
export default __webpack_public_path__ + "static/media/text-to-speech.6fe4f70612e9c1fc9284b237f7fd22ca.svg";
export { ForwardRef as ReactComponent };